import React from "react";
import { Container, Typography, Box } from "@mui/material";
import AboutSection from "./AboutSection";
import HeroSection from "./HeroSection";
import AboutHeroSection from "./AboutHeroSection";
import MainSection from "./MainSection";
import MissionSection from "./MissionSection";
import { useMediaQuery,} from "@mui/material";
import { useTheme } from "@mui/material/styles";
const AboutPage = () => {
   const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"))
  return (
    // <Container maxWidth="xl">
    <Box>
      <Box sx={{ my: 0,p:0, mt: isMobile?11:9, }}>
        <Box>
        <AboutSection/>
        </Box>
        <Box sx={{backgroundColor:"#ffffff"}}>
          <HeroSection/>
      </Box>
      <Box sx={{backgroundColor:"#EFF4F8"}}>
          <AboutHeroSection/>

      </Box>
      <Box sx={{backgroundColor:"#ffffff"}}>
          <MainSection/>

      </Box>
      <Box sx={{backgroundColor:"#EFF4F8"}}>
          <MissionSection/>

      </Box>
      </Box>
      </Box>

  )
};

export default AboutPage;
